import { replaceResource } from '@/utils';
import { usePeriodCountdown } from '@/hooks/use-period-countdown';

import { useReward } from '@/contexts/reward-context';

export const RewardTasksPeriodCountdown = ({ 
	periodEndDate 
}: {
	periodEndDate: string
}) => {
	const countdownHours = usePeriodCountdown(periodEndDate);
	const { labels } = useReward();

	return (
		<div className="reward-chlg-text">
			{countdownHours < 1 
				? labels?.lbl_RPEndingSoon 
				: replaceResource(labels?.lbl_RPHoursLeft as string, `${countdownHours}`)
			}
		</div>
	);
};